function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Vue from 'vue';
import VueRouter from 'vue-router';
import iView from 'view-design';
import util from '@/libs/util';
import Setting from '@/setting.ht';
import store from '@/store/index';
import { postApi } from '@/api';
import statementOfAccountModal from '@//pages/paySettlementModule/finMatchingSettlementMenu/finMatchingSettlementMenu/components/statementOfAccountModal.vue'; // 路由数据

import routes from './routes';
import { isInWhiteList, marketIsInWhiteList } from './routes';
Vue.use(VueRouter); // 导出路由 在 main.js 里使用

var router = new VueRouter({
  routes: routes,
  mode: Setting.routerMode,
  base: Setting.routerBase
}); // 获取菜单数据

var getMenuInfo = function getMenuInfo(menuCode) {
  var menuList = JSON.parse(sessionStorage.getItem('menuList'));
  var nowPageInfo = {};

  if (menuList) {
    menuList.forEach(function (item) {
      if (item.subMenus && item.subMenus.length) {
        item.subMenus.forEach(function (sItem) {
          if (sItem.subMenus.length) {
            sItem.subMenus.forEach(function (kItem) {
              if (kItem.menuCode == menuCode) {
                nowPageInfo = kItem;
              }
            });
          }
        });
      }
    });
  }

  return nowPageInfo;
}; // 查询内部买家是否有未确认对账单


var handlerExistStatementOfAccount = function handlerExistStatementOfAccount(userInfo) {
  return new Promise(function (resolve, reject) {
    var param = {
      pageNo: 1,
      pageSize: 10,
      orderState: '1004',
      orderStates: ['1004'],
      makeType: 3,
      receiveType: 1,
      orderFlow: 0,
      departmentCode: userInfo.orgIdIn
    };
    postApi(DYC_URL.dyc_qryOrderList, param).then(function (res) {
      if (res && res.rows.length) {
        resolve(true);
      } else {
        resolve(false);
      }
    }).catch(function (e) {
      Vue.prototype.$Modal.error({
        title: '提示',
        content: e.message,
        onOk: function onOk() {}
      });
    });
  });
}; // 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题


var originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
/**
 * 路由拦截
 * 权限验证
 */


router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var isMarkedRoute, token, userInfo, canToPageList, isExist, componentInstance, el, _token, menuCodeList, memUserType, authContrlFn, userData, fn, marketRoute, _token2, name;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isMarkedRoute = /^\/market/.test(to.path); // 判断是否是电器集市页面

            if (isMarkedRoute) {
              _context.next = 23;
              break;
            }

            // 链上u谷路由逻辑
            if (Setting.showProgressBar) iView.LoadingBar.start();
            token = util.cookies.get('auth-token');

            if (!(window.top === window.self)) {
              _context.next = 20;
              break;
            }

            // 判断是否是iframe嵌套嵌套不走这逻辑
            userInfo = store.getters['admin/global.v1/getUserInfo']; // 'finTradeStatementDetails' // 对账详情
            // 'agrTradeInvoiceDownload' // 预览
            // 'ecTradeReceiptOfStatement' // 签收发票
            // 'ecTradeBilConfirmStatement' // 确认对账

            if (!(token && !userInfo.userId && to.query.form == 'ld')) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return store.dispatch('admin/global.v1/login', {
              form: 'ld'
            });

          case 9:
            userInfo = _context.sent;

          case 10:
            canToPageList = ['finTradeStatementDetails', 'agrTradeInvoiceDownload', 'ecTradeReceiptOfStatement', 'ecTradeBilConfirmStatement', 'finMatchingBillList'];

            if (!(token && userInfo && userInfo.tradeUserTypeSelectCook == '1' && ['3', '4'].includes(userInfo.userTypeIn))) {
              _context.next = 19;
              break;
            }

            _context.next = 14;
            return handlerExistStatementOfAccount(userInfo);

          case 14:
            isExist = _context.sent;

            if (!isExist) {
              _context.next = 19;
              break;
            }

            store.commit('admin/global.v1/SET_IS_EXIST_STATEMENT_OF_ACCOUNT', true);

            if (canToPageList.includes(to.name) || to.name == 'iframe' && (to.params.menuCode == 'lcpOrderDetail' || to.params.menuCode == 'lcpDivideOrde')) {
              // 对账单里面的操作页面
              next();
            } else if (canToPageList.includes(from.name)) {
              // 从对账单页面跳转提示
              Vue.prototype.$Modal.warning({
                title: '提示',
                content: '当前存在未确认的对账单，请先确认后再进行其他操作。',
                onOk: function onOk() {
                  iView.LoadingBar.finish();
                }
              });
            } else {
              componentInstance = Vue.extend(statementOfAccountModal);
              el = document.createElement('div');
              document.getElementById('app').appendChild(el);
              new componentInstance().$mount(el);
            }

            return _context.abrupt("return");

          case 19:
            store.commit('admin/global.v1/SET_IS_EXIST_STATEMENT_OF_ACCOUNT', false);

          case 20:
            // 判断是否需要登录才可以进入
            if (isInWhiteList(to.name)) {
              // 路由白名单，直接通过
              next();
            } else {
              // 判断是否登录
              _token = util.cookies.get('auth-token');

              if (!_token) {
                // 未登录
                next({
                  name: 'login',
                  query: {
                    redirect: location.href
                  }
                });
              } else {
                // 已登录
                menuCodeList = [];
                memUserType = ''; // 闭包函数：判断是否有访问权限，并做相应跳转处理

                authContrlFn = function authContrlFn() {
                  var isAllowAccess = menuCodeList.some(function (mc) {
                    if (to.meta.isCheckMenu) {
                      if (to.name == 'iframe') {
                        // iframe菜单权限校验
                        return to.params.menuCode === mc;
                      }

                      return to.meta.belongMenus.some(function (bm) {
                        return mc === bm;
                      });
                    } else {
                      return true;
                    }
                  });

                  if (isAllowAccess) {
                    // 已分配菜单权限
                    next();
                  } else {
                    // 标准商品-商品分类管理路由权限配置(待删除staCommodityCategoryList  staCommidityList)
                    if (to.meta.belongMenus[0] == 'agrCreateCommodityList') {
                      next();
                    } else {
                      // 未分配菜单权限
                      Vue.prototype.$Modal.warning({
                        title: '提示',
                        content: '很抱歉，您无权访问跳转的页面，请联系管理员配置菜单权限，点击【确定】返回首页!',
                        onOk: function onOk() {
                          if (from.path == '/') {
                            if (!from.name) {
                              next('/');
                            } else if (Setting.showProgressBar) {
                              iView.LoadingBar.finish();
                            }
                          } else {
                            next('/');
                          }
                        }
                      });
                    }
                  }
                };

                userData = JSON.parse(localStorage.getItem('userData'));

                fn = function fn() {
                  if (memUserType == '1') {
                    store.dispatch('admin/global.v1/getIsUserBan', userData.userInfo.userIdIn).then(function (res) {
                      if (res && res.stopStatus == '00') {
                        // 停用
                        Vue.prototype.$Modal.warning({
                          title: '提示',
                          content: '您的账号已停用，请联系系统管理员',
                          onOk: function onOk() {
                            store.dispatch('admin/global.v1/signOut', {
                              isLogin: false,
                              userInfo: ''
                            });
                            next('/login');
                          }
                        });
                      } else {
                        authContrlFn();
                      }
                    }).catch(function () {
                      authContrlFn();
                    });
                  } else {
                    authContrlFn();
                  }
                }; // 获取menuCodeList数据


                if (userData) {
                  menuCodeList = userData.userInfo.menuCodeList || [];
                  memUserType = userData.userInfo.memUserType;
                  fn();
                } else {
                  postApi(DYC_URL.umc_getUserInfo, {}).then(function (res) {
                    menuCodeList = res.menuCodeList || [];
                    memUserType = res.memUserType;
                    fn();
                  });
                }
              }
            } // 废弃的iview admin pro代码（待删除）
            // if (to.matched.some(_ => _.meta.auth)) {
            //   // 这里依据 token 判断是否登录，可视情况修改
            //   const token = util.cookies.get('token');
            //
            //   if (token && token !== 'undefined') {
            //     next();
            //   } else {
            //     // 没有登录的时候跳转到登录界面
            //     // 携带上登录成功之后需要跳转的页面完整路径
            //     next({
            //       name: 'login',
            //       query: {
            //         redirect: to.fullPath
            //       }
            //     });
            //   }
            // } else {
            //   // 不需要身份校验 直接通过
            //   next();
            // }


            _context.next = 27;
            break;

          case 23:
            if (Setting.showProgressBar) iView.LoadingBar.start(); // 修改平台类型

            marketRoute = to.matched.find(function (item) {
              return item.path === '/market';
            });

            if (marketRoute && marketRoute.meta.platformType) {
              store.dispatch('market/user/setPlatformType', marketRoute.meta.platformType);
            } // 电器集市路由逻辑


            if (marketIsInWhiteList(to.name)) {
              // 路由白名单，直接通过
              next();
            } else {
              // 判断是否登录
              _token2 = util.cookies.get('auth-token');

              if (!_token2) {
                // 未登录
                name = function name() {
                  var platformType = store.getters['market/user/platformType'];

                  switch (platformType) {
                    case CONSTANT.SHOP:
                      // 电器集市商城首页
                      return 'market';

                    case CONSTANT.SUPPLIER:
                      // 电器集市供应商首页(待定)
                      return 'market';

                    default:
                      return 'login';
                    // 兜底跳转链上u谷
                  }
                };

                next({
                  name: name(),
                  query: {
                    redirect: location.href
                  }
                });
              } else {
                next();
              } // next();

            }

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  if (Setting.showProgressBar) iView.LoadingBar.finish(); // 多页控制 打开新的页面

  store.dispatch('admin/page.ht/open', to); // const menuCode = to.name === 'iframe' ? to.params.menuCode : to.name;
  // let pageInfo = getMenuInfo(menuCode);
  // 更改标题
  // util.title({
  //   title: pageInfo.menuName || to.meta.title
  // });
  // 返回页面顶端

  if (to.name == 'shopping' && to.hash.indexOf('#') == 0) {} else {
    window.scrollTo(0, 0);
  }
}); // router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     router.replace(targetPath);
//   }
// });

export default router;